import clsx from "clsx";
import { AgingReport, AgingReportMessage, AgingReportMessageResponse, toMonthYear, toPrettyDate } from "common";
import React, { useState } from "react";
import { notify } from "../util/notify";
import { useUser } from "../store";

export default function ReportMessage({ message, refreshReport, parentReport, onReply }: { parentReport: AgingReport, message: AgingReportMessage; onReply: (months: string[]) => void; refreshReport: (report: AgingReport) => void }) {
    const [collapsed, setCollapsed] = useState<boolean>(false);
    const { invokeApi, isAdmin, user } = useUser();


    const deleteReportMessage = () => {
        if (window.confirm("Are you sure you want to delete this message?")) {
            invokeApi({
                endpoint: "/deleteReportMessage",
                data: {
                    residentName: parentReport.residentName,
                    billType: parentReport.billType,
                    index: parentReport.index,
                    messageId: message.id,
                },
            }).then((report: AgingReport) => {
                notify.success("Message deleted!");
                refreshReport(report);
            });
        }
    };

    const deleteResponse = (response: AgingReportMessageResponse) => {
        if (window.confirm("Are you sure you want to delete this response?")) {
            invokeApi({
                endpoint: "/deleteReportMessageResponse",
                data: {
                    residentName: parentReport.residentName,
                    billType: parentReport.billType,
                    index: parentReport.index,
                    messageId: message.id,
                    responseId: response.id,
                },
            }).then((report: AgingReport) => {
                notify.success("Response deleted!");
                refreshReport(report);
            });
        }
    };

    const canDeleteMessage = (username: string) => isAdmin || username === user?.username;

    return (
        <div key={message.id} className="thread">

            <div className="month-badge">
                {message.months.map(toMonthYear).join('-') || "N/A"} <span className="response-count">({message.responses.length + 1 || 1})</span>
            </div>

            <div className="message-card" >
                <div className="message-top">
                    <div className="message-text">{message.author}: {message.message} </div>
                    <div className="message-right">
                        <i className="fa-solid fa-reply" onClick={() => {
                            onReply(message.months);
                        }}></i>
                        {canDeleteMessage(message.author) &&
                            <i className="fa-solid fa-trash" onClick={() => deleteReportMessage()}></i>
                        }
                        <i className={`fa-solid ${collapsed ? 'fa-square-plus' : 'fa-square-minus'}`} onClick={() => setCollapsed(!collapsed)}></i>
                    </div>
                </div>

                <div className="meta">
                    <span>Sent: {toPrettyDate(message.createdAt)}</span>
                    {message.deadline && <span className="deadline">Deadline: {toPrettyDate(message.deadline)}</span>}
                </div>
            </div>

            {!collapsed && (
                <div className="responses">
                    {message.responses.map(response => (
                        <div key={response.id} className="response-card">
                            <div className="message-top">
                                <div className="message-text">
                                    {response.author}: {response.message}
                                </div>
                                {canDeleteMessage(message.author) &&
                                    <div className="message-right">
                                        <i className="fa-solid fa-trash" onClick={() => deleteResponse(response)}></i>
                                    </div>
                                }
                            </div>

                            <div className="meta">
                                <span className="sent">Sent: {toPrettyDate(response.createdAt)}</span>
                                {response.deadline && <span className="deadline">Deadline: {toPrettyDate(response.deadline)}</span>}
                            </div>
                        </div>
                    ))}
                </div>
            )
            }

        </div >
    );
}